import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Gate: React.FC<Props> = ({ fill }) => {
    return (
        <Svg width="12pt" height="100%" viewBox="0 0 640 640">
            <Path
                fill={fill}
                d="M256 288L256 480L320 480L320 288L256 288zM512 209C465.3 214.8 426.4 245.8 409.3 288L384 288L384 378.8C373.9 394 368 412.2 368 431.9L368 527.9C368 533.4 368.5 538.8 369.3 544L128 544C92.7 544 64 515.3 64 480L64 160C64 124.7 92.7 96 128 96L448 96C483.3 96 512 124.7 512 160L512 209zM128 288L128 480L192 480L192 288L128 288zM560 336C559.9 318.4 545.6 304.1 528 304.1C510.3 304.1 496 318.4 496 336.1L496 384L592 384C618.5 384 640 405.5 640 432L640 528C640 554.5 618.5 576 592 576L464 576C437.5 576 416 554.5 416 528L416 432C416 411.1 429.4 393.3 448 386.7L448 336.1C448 291.9 483.8 256.1 528 256.1C572.2 256.1 607.9 291.9 608 336L560 336z"
            />
        </Svg>
    );
};

export default Gate;
